(function () {
    if (window.location.pathname.indexOf('/search') === 0) {
        // Obtener el título actual
        var currentTitle = document.title;
        // Nueva expresión regular que coincide con el formato actual
        var titleRegex = /Search:\s*(\d+)\s*results\s*found\s*for\s*["""]([^"""]+)["""]/i;

        var titleMatch = currentTitle.match(titleRegex);

        if (titleMatch) {
            var resultCount = titleMatch[1];
            var searchTerm = titleMatch[2];

            // Capitalizar la primera letra de cada palabra del término de búsqueda
            var capitalizedTerm = searchTerm
                .split(' ')
                .map(function (word) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                })
                .join(' ');

            // Crear el nuevo formato de título
            var newTitle = resultCount + ' Search Results for ' + capitalizedTerm + ' | Sockwell';

            // Actualizar el título
            document.title = newTitle;
        }
    }

    // Agregar un observador para detectar cambios en el título
    var titleObserver = new MutationObserver(function () {
        var currentTitle = document.title;
        if (!currentTitle.startsWith(resultCount + ' Search Results')) {
            document.title = newTitle;
        }
    });

    // Configurar el observador para monitorear cambios en el título
    titleObserver.observe(document.querySelector('title'), {
        subtree: true,
        characterData: true,
        childList: true,
    });

    // Agregar un evento al cargar completamente la página
    window.addEventListener('load', function () {
        // Volver a establecer el título después de que todo se haya cargado
        setTimeout(function () {
            document.title = newTitle;
        }, 200);
    });

})();